import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  createNotificationDevice(notificationDevice) {
    return RetailerApiClient.post('notification-devices', notificationDevice)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
